import { Filters } from './filter-sort';
import { BackendPlan } from './plans';

export function getAnalyticPlanDescription(plan: BackendPlan) {
    return plan.producerRecommended ? 'recommended' : plan?.pickOrder && plan?.pickOrder > -1 ? 'top' : 'standard';
}

export function getAnalyticPageDescription(filters: Filters) {
    // TODO: fix me with top pick
    // return filters.topPick ? 'top' : 'all';
    return filters ? 'all' : 'all';
}

export function getHostURL() {
    // below is from an email
    return `${window.location.origin}/assets/shopper/public/quote`;
    // old code. May be used later when moving off wcms
    const href = window.location.href;
    if (href.endsWith('/')) {
        return href.slice(0, -1);
    }
    return href;
}
